import { Component } from '@angular/core';

@Component({
  selector: 'app-reset.dialog',
  standalone: false,
  templateUrl: './reset.dialog.component.html',
  styleUrl: './reset.dialog.component.scss'
})
export class ResetDialogComponent {

}
